import React from 'react';
import BaseButton from '../form/BaseButton.jsx';
import BaseOverlay from '../layout/BaseOverlay.jsx';
import BaseDropdown from '../form/BaseDropdown.jsx';
import { InputNumber } from 'primereact/inputnumber';
import { Calendar } from 'primereact/calendar';
import { MultiSelect } from 'primereact/multiselect';
import IconCancel from '../images/IconCancel.jsx';

const AdvancedSearchFilterOrganizations = ({
    filters,
    visible,
    setVisible,
    config,
    changeFilter,
    applyFilters,
    setApplied,
    loadingOwnership
}) => {
    const hideDialog = () => {
        setVisible(false);
    };

    const filter = () => {
        applyFilters();
        setApplied(true);
        hideDialog();
    };

    const renderDropdown = ({ field, title, options, placeholder }) => {
        return (
            <div className={'mb-[30px]'} key={field}>
                <h2 className='pb-[10px] text-xl font-bold'>{title}</h2>
                <BaseDropdown
                    id={field}
                    name={field}
                    placeholder={placeholder}
                    value={filters[field]}
                    options={options}
                    setValue={(selectedValue) => changeFilter(field, null, selectedValue)}
                    filter={false}
                    disabled={loadingOwnership}
                />
            </div>
        );
    };

    const renderMultiSelect = ({ field, title, options, placeholder }) => {
        return (
            <div className={'mb-[30px] leading-tight'} key={field}>
                <h2 className='pb-[10px] text-xl font-bold'>{title}</h2>
                <div className='flex items-center'>
                    <MultiSelect
                        value={filters[field]}
                        onChange={(e) => changeFilter(field, null, e.value)}
                        options={options}
                        optionLabel='label'
                        filter
                        placeholder={placeholder}
                        maxSelectedLabels={3}
                        className={`bg-transparent border-theme1-text3 border rounded-4xl px-2 ${filters[field].length > 0 ? 'w-[90%]' : 'w-full'}`}
                    />

                    {filters[field].length > 0 && (
                        <div
                            className='cursor-pointer w-[36px] pl-[40px] flex-shrink-0'
                            onClick={() => changeFilter(field, null, [])}
                        >
                            <IconCancel className='fill-theme1-primary' />
                        </div>
                    )}
                </div>
            </div>
        );
    };

    const renderTextInput = ({ field, title, placeholder }) => {
        return (
            <div className={'mb-[30px]'} key={field}>
                <h2 className='pb-[10px] text-xl font-bold'>{title}</h2>
                <input
                    type='text'
                    value={filters[field]}
                    onChange={(e) => changeFilter(field, null, e.target.value)}
                    placeholder={placeholder}
                    className='w-full bg-transparent border-theme1-text3 border rounded-4xl px-4 py-2'
                />
            </div>
        );
    };

    const renderRangeInputs = ({ field, title, placeholderMin, placeholderMax }) => {
        return (
            <div className={'mb-[30px]'} key={field}>
                <h2 className='pb-[10px] text-xl font-bold'>{title}</h2>
                <div className='flex gap-4 flex-col sm:flex-row'>
                    <InputNumber
                        value={filters[field]?.min || ''}
                        onValueChange={(e) => changeFilter(field, 'min', e.value)}
                        placeholder={placeholderMin}
                        className='w-full bg-transparent border-theme1-text3 border rounded-4xl px-4 py-2'
                    />
                    <InputNumber
                        value={filters[field]?.max || ''}
                        onValueChange={(e) => changeFilter(field, 'max', e.value)}
                        placeholder={placeholderMax}
                        className='w-full bg-transparent border-theme1-text3 border rounded-4xl px-4 py-2'
                    />
                </div>
            </div>
        );
    };

    const renderYearPicker = ({ field, title }) => {
        return (
            <div className={'mb-[30px]'} key={field}>
                <h2 className='pb-[10px] text-xl font-bold'>{title}</h2>
                <Calendar
                    placeholder={title}
                    value={filters[field] ? new Date(filters[field], 0) : null}
                    onChange={(e) => {
                        const year = e.value ? e.value.getFullYear().toString() : '';
                        changeFilter(field, null, year);
                    }}
                    view='year'
                    dateFormat='yy'
                    className='w-full bg-transparent border-theme1-text3 border rounded-4xl px-4 py-2'
                />
            </div>
        );
    };

    return (
        <BaseOverlay show={visible} className='overflow-auto h-[100dvh] rounded-none'>
            <div className='min-h-96 max-w-3xl w-full mx-auto p-4'>
                <div className='flex justify-end py-4'>
                    <div className='text-theme1-primary font-bold cursor-pointer' onClick={hideDialog}>
                        Close
                    </div>
                </div>
                <div className='text-center text-theme1-title2 font-bold text-[22px] mb-3'>Filter</div>
                <div className={'text-left'}>
                    {config.map((item) => {
                        switch (item.type) {
                            case 'dropdown':
                                return renderDropdown(item);
                            case 'multiselect':
                                return renderMultiSelect(item);
                            case 'text':
                                return renderTextInput(item);
                            case 'range':
                                return renderRangeInputs(item);
                            case 'yearpicker':
                                return renderYearPicker(item);
                        }
                    })}
                    <div className='flex justify-between gap-4 w-full'>
                        <BaseButton
                            className='bg-theme1-primary text-theme1-white flex-shrink-0'
                            textValue='Apply Filters'
                            onClick={filter}
                        />
                    </div>
                </div>
            </div>
        </BaseOverlay>
    );
};

export default AdvancedSearchFilterOrganizations;
